import loadable from '@loadable/component';

export const PracticalmotorhomeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "practicalmotorhome-site" */ './PracticalmotorhomeSiteWrapper'),
);
